export default {"src":"/_next/static/media/LIVE_STATUS.d0a50fdc.svg","height":32,"width":76,"blurWidth":0,"blurHeight":0};